// Caminhos do módulo num lugar só. Orçamento e proposta comercial são a mesma
// entidade no banco (lais_propostas), mas abrem em editores diferentes: quem
// navega para "editar" decide pelo `tipo` do documento, não pela URL antiga.
export const ROTA_PROPOSTAS = '/dashboard/propostas';
export const ROTA_NOVA_PROPOSTA = `${ROTA_PROPOSTAS}/nova`;
export const ROTA_NOVO_ORCAMENTO = `${ROTA_PROPOSTAS}/orcamentos/novo`;

export const isOrcamento = (proposta) => proposta?.tipo === 'orcamento';

export const rotuloTipo = (proposta) => (isOrcamento(proposta) ? 'Orçamento' : 'Proposta');

export const iconeTipo = (proposta) => (isOrcamento(proposta) ? 'mdi:receipt-text-outline' : 'mdi:file-document-outline');

/**
 * URL de edição de um documento. Aceita o objeto (usa `tipo`) ou só o id (cai no
 * editor completo — o PropostaEditor redireciona para o de orçamento se for o caso).
 * `qs` é a querystring sem o "?" (ex.: "lead_id=...&voltar=negocio").
 */
export function caminhoEdicao(proposta, qs) {
  const id = typeof proposta === 'object' ? proposta?._id : proposta;
  const base = isOrcamento(proposta)
    ? `${ROTA_PROPOSTAS}/orcamentos/${id}/editar`
    : `${ROTA_PROPOSTAS}/${id}/editar`;
  return qs ? `${base}?${qs}` : base;
}
